import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, UserCheck, UserX } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const AffectationsStatsCards = ({ employees }) => {
  const { t } = useTranslation();
  const withCalendar = employees.filter((emp) => emp.current_calendar !== null).length;
  const withoutCalendar = employees.length - withCalendar;
  const pct = (n) => (employees.length > 0 ? Math.round((n / employees.length) * 100) : 0);

  return (
    <div className="grid gap-4 md:grid-cols-3 mb-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">{t('holidayAssignments.stats.totalEmployees')}</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{employees.length}</div>
          <p className="text-xs text-muted-foreground">{t('holidayAssignments.stats.employeesInSystem')}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">{t('holidayAssignments.stats.withCalendar')}</CardTitle>
          <UserCheck className="h-4 w-4 text-green-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-green-600">{withCalendar}</div>
          <p className="text-xs text-muted-foreground">{t('holidayAssignments.stats.percentOfTotal', { pct: pct(withCalendar) })}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">{t('holidayAssignments.stats.withoutCalendar')}</CardTitle>
          <UserX className="h-4 w-4 text-orange-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-orange-600">{withoutCalendar}</div>
          <p className="text-xs text-muted-foreground">{t('holidayAssignments.stats.percentOfTotal', { pct: pct(withoutCalendar) })}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AffectationsStatsCards;
